var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.615 16C1.155 16 0.771 15.846 0.463 15.538C0.154333 15.2293 0 14.845 0 14.385V4.615C0 4.155 0.154333 3.771 0.463 3.463C0.771 3.15433 1.155 3 1.615 3H6V1.615C6 1.155 6.15433 0.771 6.463 0.463C6.771 0.154333 7.155 0 7.615 0H10.385C10.845 0 11.2293 0.154333 11.538 0.463C11.846 0.771 12 1.155 12 1.615V3H16.385C16.845 3 17.229 3.15433 17.537 3.463C17.8457 3.771 18 4.155 18 4.615V14.385C18 14.845 17.846 15.229 17.538 15.537C17.2293 15.8457 16.845 16 16.385 16H1.615ZM1.615 15H16.385C16.5383 15 16.6793 14.936 16.808 14.808C16.936 14.6793 17 14.5383 17 14.385V4.615C17 4.46167 16.936 4.32067 16.808 4.192C16.6793 4.064 16.5383 4 16.385 4H1.615C1.46167 4 1.32067 4.064 1.192 4.192C1.064 4.32067 1 4.46167 1 4.615V14.385C1 14.5383 1.064 14.6793 1.192 14.808C1.32067 14.936 1.46167 15 1.615 15ZM7 3H11V1.615C11 1.46167 10.936 1.32067 10.808 1.192C10.6793 1.064 10.5383 1 10.385 1H7.615C7.46167 1 7.32067 1.064 7.192 1.192C7.064 1.32067 7 1.46167 7 1.615V3Z",
    fill: "#333132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.8f3175ed1b5ef55b97a5f47330b31527.svg";
export { ForwardRef as ReactComponent };